import { AddressInputField, UploadInput, Button } from "@/components";
import { SheetClose } from "@/components/ui/sheet";
import { useEffect, useState, memo } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { useFormData, useAlert } from "@/";
import {
  raiseWeightDispute,
  takeWeightDisputeAction,
} from "../../../app/slices/weightDisputeSlice";

function WeightDisputeForm({ ids = [], setSheetOpen = () => {} }) {
  const { alert, AlertDialog } = useAlert();
  const dispatch = useDispatch();
  const convertToFromData = useFormData();
  const [formData, setFormData] = useState({
    remark: "",
    attachment: "",
  });

  useEffect(() => {
    // This effect will run whenever formData changes
    console.log("Form data updated:", formData);
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Ids:::", ids);

    if (!formData.remark) {
      await alert("Please Enter the remarks!!!");
      return;
    }
    const body = {
      ...(formData.attachment
        ? formData.attachment.reduce(
            (acc, file, index) => ({
              ...acc,
              [`proof${index + 1}`]: file,
            }),
            {}
          )
        : {}),
      data: {
        message: formData.remark,
        shipmentIds: ids,
      },
    };

    const finalData = convertToFromData(body);

    console.log(finalData);
    try {
      const action = await dispatch(raiseWeightDispute(finalData));
      if (raiseWeightDispute.fulfilled.match(action)) {
        await alert("Dispute raised successfully!");
        setSheetOpen(false);
      } else if (raiseWeightDispute.rejected.match(action)) {
        console.error("Error raising dispute:", action.payload);
        await alert(
          `Failed to raise dispute : ${action.payload || "Unknown error"}`
        );
      }
    } catch (error) {
      console.error("Error raising dispute:", error);
      await alert("An unexpected error occurred while raising dispute.");
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-10">
      <div className="flex flex-col gap-2 md:gap-4">
        <AddressInputField
          label="Remark"
          placeholder="Enter Remark"
          value={formData.remark}
          onChange={(value) => handleChange("remark", value)}
        />
        <UploadInput
          label="Attachment (if any)"
          placeholder="Upload any evidences you have"
          value={formData.attachment}
          multiple={true}
          onChange={(value) => handleChange("attachment", value)}
          note="Note: File type should only be pdf, png, jpeg and should be in color and Maximum file size is 5MB."
        />
      </div>
      <div className="flex gap-2 justify-end items-center">
        <SheetClose asChild>
          <Button variant="outline" size="sm" type="button">
            Cancel
          </Button>
        </SheetClose>
        <Button variant="default" size="sm" icon={AiOutlineCheck} type="submit">
          Submit
        </Button>
      </div>
      <AlertDialog />
    </form>
  );
}

export default memo(WeightDisputeForm);
